import * as React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import { distances, colors, globalPageMaxWidth } from '../../../styles/constants';
import { H2 } from '../../../components/Typography';

interface CardProps {
    children: any;
    title: any;
    onDuplicate: () => void;
    onRemove: () => void;
    subtitle?: string;
    noPadding?: boolean;
    marginBottom?: string;
    shortHr?: boolean;
}

const CampaignCard = (props: CardProps) => {
    const { t } = useTranslation();

    return (
        <CardWrapper noPadding={props.noPadding} marginBottom={props.marginBottom}>
            <React.Fragment>
                <TitleWrapper>
                    <H2>{props.title}</H2>
                    <div>
                        <ActionButton type="button" onClick={() => props.onDuplicate()}>
                            {t('marketing.campaign.duplicate')}
                        </ActionButton>
                        <ActionButton type="button" onClick={() => props.onRemove()}>
                            {t('marketing.campaign.remove')}
                        </ActionButton>
                    </div>
                </TitleWrapper>
                <CardSubtitle>{props.subtitle}</CardSubtitle>
                {props.shortHr ? <ShortCardHr /> : <CardHr />}
            </React.Fragment>
            {props.children}
        </CardWrapper>
    );
};

interface WrapperProps {
    noPadding?: boolean;
    marginBottom?: string;
}

const CardWrapper = styled.section<WrapperProps>`
    background: ${colors.background};
    color: ${colors.text};
    padding: ${(props) => (props.noPadding ? '0' : distances.normal)};
    margin-bottom: ${(props) => props.marginBottom || '0px'};
    max-width: ${globalPageMaxWidth}px;
    width: 100%;
    border-radius: 2px;
    position: relative;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
    display: inline-block;
`;

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const ActionButton = styled.button`
    border: none;
    background: none;
    cursor: pointer;

    &:focus {
        outline: none;
    }
`;

const CardHr = styled.hr`
    margin: ${distances.tiny} -${distances.normal};
    padding: 0;
    border: 0;
    height: 2px;
    background: ${colors.borderLight};
`;

const ShortCardHr = styled.hr`
    padding: 0;
    border: 0;
    height: 2px;
    background: ${colors.borderLight};
`;

const CardSubtitle = styled(H2 as any)`
    color: ${colors.borderDark};
`;

export default CampaignCard;
